import { v4 as uuid } from 'uuid';

/**
 * Utility for generating badge print event IDs for cross-application tracing
 */

export function generateBadgePrintEventId(): string {
  return uuid();
}
